<template>
  <landing-page
    label="services.ourCheckupServices"
    description="services.healthCheckupIntroDesc"
    :labelColor="labelAndDescColor"
    :descColor="labelAndDescColor"
    :eggImgObj="{ componentName: 'services', imgName: 'ourCheckupPackageIntro', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useServicesStore } from "@/stores/services";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const servicesStore = useServicesStore();
const commonStore = useCommonStore();
const router = useRouter();
const i18n = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const props = defineProps({
  labelAndDescColor: {
    type: String,
    default: "#7BA7D8",
  }
});
</script>